import React from 'react';

import type { NormalizedAddress } from './utils';
import { CopyButton } from '../CopyButton';

type AddressDetailsProps = {
  title?: string;
  address: NormalizedAddress;
  className?: string;
};

const AddressDetailRow = React.memo(
  ({ label, value }: { label: string; value: string | undefined }) => (
    <>
      <div className="font-medium">{label}</div>
      <div className="flex items-center">
        {value}
        {value?.trim() && <CopyButton textToCopy={value} />}
      </div>
    </>
  ),
);

AddressDetailRow.displayName = 'AddressDetailRow';

export const AddressDetails: React.FC<AddressDetailsProps> = ({ title, address, className }) => {
  return (
    <div className={className}>
      {title && <h3 className="mb-4 text-xl font-semibold">{title}</h3>}

      <div className="flex flex-col space-y-2 pr-6">
        <div className="grid grid-cols-2 gap-4">
          <AddressDetailRow label="Country" value={address.country} />
          <AddressDetailRow label="State / Province / Region" value={address.state} />
          <AddressDetailRow label="City / Town" value={address.city} />
          <AddressDetailRow label="Street" value={address.street} />
          <AddressDetailRow label="Number" value={address.number} />
          <AddressDetailRow label="ZIP / Postal Code" value={address.postalCode} />
        </div>
      </div>
    </div>
  );
};
